import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./store/configureStore";
import App from "./App";
import { registerSW } from "virtual:pwa-register";

// Installs/updates the service worker that keeps the app shell available offline.
registerSW({ immediate: true });

const store = configureStore();
if (import.meta.env.DEV) window.__singatStore = store; // for poking at the state from the console

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
